<script>
export default {
  name: "UploadFileButtonComponent",
  props: {
    onChangeFileHandler: {
      type: Function,
      required: true
    },
    objectIndex: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div class="upload-action">
    <div class="upload-btn">
      <a href="#" onclick="return false;">Добавить документ</a>
      <input type="file" multiple="" @change="(event) => onChangeFileHandler(event, objectIndex)">
    </div>
    <span class="upload-btn-info"><i>Фото/скан паспорта или св-ва о смерти ПОДГРУЖАТЬ НЕ НУЖНО!</i></span>
  </div>
</template>

<style scoped>

.upload-btn {
  position: relative;
  overflow: hidden;
  background-color: #3294ca;
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 5px;
  border: 1px solid #307399;
  padding: 5px 10px;
  margin-top: 5px;
  border-radius: 5px;
}

.upload-btn a {
  font-size: 18px;
  color: #ffffff;
}

.upload-btn input[type=file] {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.upload-btn-info {
  margin-left: 10px;
  color: #000;
  font-weight: 500;
  text-decoration: underline;
}

@media (max-width: 768px) {

  .upload-action {
    text-align: center;
  }

  .upload-btn-info {
    display: block;
    margin: 5px 0;
  }

}

</style>
